import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { Device } from '../../classess/device/device';
import { getProcessButtons, isUndNullEmp, getResponse, settings, styles, handleResponseMessageAsync } from '../../helpers/main';
import { DeviceService } from '../../services/devices/DeviceService';

const { icons, images, labels, messages } = settings;

export default function DeviceAddEditDetails({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageId: 'en',
        dtDevicesId: '',
        dtDevicesRowId: 0,
    },
    setModalObj = {},
    device = Device?.getClass({}, false),
    setDevice = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });
    const [errors, setErrors] = useState({
        name: '',
    });
    const [dataFormLength] = useState(Device.minMaxLength(false));

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'inputModalName',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    const addDevice = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'addDevice';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await DeviceService.create({
                auth: modalObj?.auth,
                data: device,
                languageId: modalObj?.languageId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const newDevice = Device?.getClass(response?.result?.device || {}, false);

            //#region datatable add
            modalObj.$(`#${modalObj.dtDevicesId}`).DataTable().row.add([
                newDevice.name,
                getProcessButtons({
                    id: newDevice.id,
                    description: newDevice.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageId],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageId],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageId],
                    enabledEdit: true,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable add

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageId]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    // setShowData,
                    // showDataValue: response?.isSuccess,
                    languageId: modalObj?.languageId
                });
            }
        }
    }

    const editDevice = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'editDevice';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await DeviceService.update({
                auth: modalObj?.auth,
                data: device,
                languageId: modalObj?.languageId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const updatedDevice = Device?.getClass(response?.result?.device || device, false);

            //#region datatable update
            modalObj.$(`#${modalObj.dtDevicesId}`).DataTable().row(modalObj.dtDevicesRowId).data([
                updatedDevice.name,
                getProcessButtons({
                    id: updatedDevice.id,
                    description: updatedDevice.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageId],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageId],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageId],
                    enabledEdit: true,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable update

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageId]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    // setShowData,
                    // showDataValue: response?.isSuccess,
                    languageId: modalObj?.languageId
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmp({ data: device?.name, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, name: `${messages?.thisFieldRequired?.[modalObj?.languageId]}.` }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                name: '',
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        }
    }, []);
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='devices' src={images?.icons?.devices} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.device?.[modalObj?.languageId]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageId] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageId] :
                                        labels?.detail?.[modalObj?.languageId]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className={controls?.buttons?.closeModal?.defaultClass}
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.showLoading}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: 'form - ModalHeader', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => modalObj?.type === 0 ?
                addDevice({ e: e, subMethod: 'form - onSubmit' }) :
                editDevice({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageId]}
                                        </small>
                                        <div className='input-group'>
                                            <input id={controls?.inputs?.name?.id}
                                                className='form-control bg-light border-0 shadow-sm text-dark'
                                                style={{ borderRadius: '5px' }}
                                                maxLength={dataFormLength?.max?.name}
                                                disabled={process?.showLoading}
                                                onChange={(e) => setDevice({ ...device, name: e?.target?.value })}
                                                onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                value={!isUndNullEmp({ data: device?.name, subMethod: controls?.inputs?.name?.id })?.result ? device?.name : ''}
                                                placeholder={labels?.name?.[modalObj?.languageId]}
                                                title={labels?.name?.[modalObj?.languageId]} />
                                        </div>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.name)}</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageId]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold text-dark'>
                                            {device?.name || '---'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.showLoading}
                            hidden={modalObj?.type === 2}
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageId] : labels?.save?.[modalObj?.languageId]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={icons?.fasFa?.save} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageId] : labels?.save?.[modalObj?.languageId]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className='btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.showLoading}
                            title={labels?.close?.[modalObj?.languageId]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={icons?.fasFa?.arrowCircleLeft}></i> {labels?.back?.[modalObj?.languageId]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}